/**
 *  Hotels
 *
 * @format
 */


//**** */ Hotels *****
export const FETCH_HOME_HOTELS = 'fetchHotels';
export const SET_HOME_HOTELS = 'setHotels';

export const FETCH_PROPERTY_TYPE = 'fetchPropertyTypes';
export const SET_PROPERTY_TYPE = 'setPropertyTypes';

export const FETCH_COUNTRIES = 'fetchCountries';
export const SET_COUNTRIES = 'setCountries';

export const FETCH_REGION = 'fetchRegion';
export const SET_REGION = 'setRegion';

export const FETCH_HOTEL = 'fetchHotel';
export const SET_HOTEL = 'setHotel';


export const FETCH_ALL_ROOMS_BY_HOTEL_ID = 'fetchAllRoomsByHotelId';
export const SET_ALL_ROOMS_BY_HOTEL_ID = 'setAllRoomsByHotelId';
export const FETCH_FILTERED_ROOMS = 'fetchFilteredRooms';
export const FETCH_FILTERED_ROOMS_OCCUPANCY = 'fetchFilteredRoomsOccupancy';
export const SET_FILTERED_ROOMS = 'setFilteredRooms';

export const VALIDATE_EVENT_GLOBAL_PROMOCODE = 'validateEventGlobalPromocode';

export const FETCH_FILTERED_HOTELS = 'fetchFilteredHotels';
export const FETCH_FILTERED_HOTELS_SIGNIX = 'fetchFilteredHotelsSignix';
export const FETCH_SIGNIX_PRICE_VALIDATION = 'fetchSignixPriceValidation';
export const SIGNIX_PRE_BOOK = 'signixPreBook';
export const SIGNIX_BOOK_COMPLETE = 'signixBookComplete';

export const FETCH_HOTEL_DETAIL_SIGNIX = 'fetchHotelDetailSignix';

export const SET_FILTERED_HOTELS = 'setFilteredHotels';

export const FETCH_HOTEL_NAMES = 'fetchHotelNames';
export const SET_HOTEL_NAMES = 'setHotelsNames';

export const FETCH_MEAL_PLANE = 'fetchMealPlans';
export const SET_MEAL_PLANE = 'setMealPlans';

export const FETCH_DISCOUNT_PRICE = 'fetchDiscountPrice';
export const SET_DISCOUNT_PRICE = 'setDiscountPrice';

export const FETCH_HOLD_TIMESTAMP = 'fetchHoldTimestamp';
export const SET_HOLD_TIMESTAMP = 'setHoldTimestamp';

export const VALIDATE_ROOM_CREATE_BILLING = 'validateRoomCreateBilling';
export const SET_VALID_ROOM_AND_BILLING = 'setValidRoomAndBilling';
export const SET_FINAL_TRANSACTION = 'setFinalTransaction';

export const BUY_ROOM = 'buyRoom';
export const SET_BOUGHT_ROOM = 'setBoughtRoom';

export const FETCH_SMS_PRICE = 'fetchSmsPrice';
export const SET_SMS_PRICE = 'setSmsPrice';

export const SAVE_API_BODY = 'saveApiBody';
export const SET_API_BODY = 'setApiBody';

export const SAVE_EVENT_API_BODY = 'saveEventApiBody';
export const SET_EVENT_API_BODY = 'setEventApiBody';

export const SET_DISCOUNT_MESSAGE = 'setDiscountMessage';
export const RESET_DISCOUNT_MESSAGE = 'resetDiscountMessage';

export const ROOM_PAYMENT_COMPLETE = 'roomPaymentComplete';
export const SET_ROOM_PAYMENT_COMPLETE = 'setRoomPaymentComplete';

export const REMOVE_HOLD_ROOMS = 'removeHoldRooms';
export const HOTEL_PAYMENT_CANCEL = 'hotelPaymentCancel';
export const RESET_STATE = 'resetState';
export const RESET_DISCOUNT_PRICE = 'resetDiscoutPrice';


/** User Profile */
export const REGISTER = 'userRegister';
export const SOCIAL_CONNECT = 'socialConnect';
export const LOGIN = 'userLogin';
export const LOGIN_SPARK = 'sparkUserLogin';

export const LOGIN_SOCIAL = 'socialLogin';
export const CHECK_AUTH = 'checkAuth';
export const USER_PROFILE = 'userProfile';
export const FORGOT_PASSWORD = 'forgotPassword';
export const LOGOUT = 'logout';
export const VERIFY_EMAIL = 'verifyEmail';
export const ACCOUNT_ACTIVATION = 'accountActivation';
export const UPDATE_PROFILE = 'updateProfile';
export const UPDATE_PASSWORD = 'updatePassword';
export const MY_EVENTS = 'myEvents';
export const MY_REWARD_POINTS = 'myRewardPoints';
export const MY_REWARD_SUMMARY = 'myRewardSummary';


/** Event */
export const FETCH_EVENT_CATEGORIES = 'fetchEventCategories';
export const FETCH_EVENTS = 'fetchEvents';
export const FETCH_CAT_EVENTS = 'fetchCatEvents';
export const FETCH_PROMOTIONAL_EVENTS = 'fetchPromotionalEvents';
export const FETCH_EVENT = 'fetchEvent';
export const FETCH_EVENT_BY_DATE = 'fetchEventByDate';

export const RESET_EVENT = 'resetEvent';
export const FETCH_EVENT_VIDEO = 'fetchEventVideo';
// export const FETCH_TAGS = 'fetchTags';
export const FETCH_PROMOTER = 'fetchPromoter';
export const SET_PROMOTER = 'setPromoter';
export const LEAST_TICKET_PRICE = 'leastTicketPrice';


/** Tickets */
export const FETCH_TICKETS = 'fetchTickets';
export const VALIDATE_TICKET = 'validateTickets';
export const REMOVE_HOLD_TICKET = 'removeHoldTicket';
export const TICKET_HOLD_SESSION = 'ticketHoldSession';
export const BUY_TICKET = 'buyTicket';
export const CREATE_SPARK_TOKEN = 'createSparkToken';

export const MYT_MONEY = 'myTMoney';
export const CREATE_MCB_SESSION = 'createMcbSession';
export const PAYMENT_COMPLETE = 'paymentComplete';
export const PAYMENT_CANCEL = 'paymentCancel';
export const VERIFY_QR = 'verifyQR';
export const PRINT_TICKET = 'printTicket';

export const SET_TICKET_VALIDATION_ON_PAGE_REFRESH =
  'setTicketValidationOnPageRefresh';
export const GET_LOCAL_STORAGE = 'getLocalStorage';
export const VALIDATE_EVENT_CODE = 'validateEventCode';
export const VALIDATE_EGIFT_VOUCHER = 'validateEgiftVoucher';
export const VALIDATE_SEATS = 'validateSeats';

export const SET_EGIFT_VOUCHER = 'voucherPayment';



export const SET_EVENT_CODE = 'setEventCode';

/**SeatsIO */
export const PROCESS_SEAT = 'processSeat';
export const FETCH_SEATSIO_CONFIG = 'fetchSeatsIOConfig';
export const UPDATE_BOOKING_SEATS = 'updateBookingSeats';
export const RELEASE_BOOKING_SEAT = 'releaseBookingSeat';

/**spark */
export const SPARK_TOKEN = 'sparkToken';

/**General */
export const SUBSCRIBE = 'subscribe';
export const UNSUBSCRIBE = 'unSubscribe';
export const CONTACTUS = 'contactUs';
export const SYSTEM_CONFIG = 'systemConfig';
export const NEWS_HEADLINES = 'newsHeadlines';
export const FETCH_CATEGORY_PROMOTIONAL = "categoryPromotional"
export const FETCH_PRODUCT_PROMOTIONS = "fetchProductPromotions"
export const FETCH_NEW_ITEM_CAROUSEL = "fetchNewItemCarousel"

export const FETCH_SITE_CONTENT = "fetchSiteContent"


/** Search Query */
export const FETCH_SEARCH_QUERY = "fetchSearchQuery"

/**Ad Banner */
export const FETCH_BANNER = 'fetchBanner';


// payments
export const FETCH_PAYMENTS = 'fetchPayments';
export const FETCH_PAYMENT_STATUS = "fetchPaymentStatus"
export const SET_PAYMENTS_STATUS = "setPaymentStatus"
export const FETCH_ORDER_CONFIRMATION = "fetchOrderConfirmation"
export const SET_ORDER_CONFIRMATION = "setOrderConfirmation"
export const SET_PAYMENTS = 'setPayments';
export const CHECKOUT_PAYMENTS = 'checkoutPayment'
export const INITIATE_FISERV_PAYMENT = 'initiateFiservPayment'
export const CHECKOUT_VOUCHER_PAYMENT = "checkoutVoucherPayment"
export const CHECKOUT_FLIGHT_PAYMENT = "checkoutFlightPayment"

// Refund
export const  CLAIMREFUND ='claimRefund'


export const FETCH_OCCASION = 'fetchOccasions';
export const SET_OCCASION = 'setOccasions';

export const BUY_E_GIFT = 'buyegifts';

export const VERIFY_VENDOR = 'verifyVendor';
export const CREATE_VENDOR_SESSION = 'createVendorSession';
export const VALIDATE_GLOBAL_PROMOCODE = 'validateGlobalPromocode';
// Flight
export const FLIGHT_BOOKING = 'flightBooking';
export const FLIGHT_FARE_CONFIRMATION = 'flightFareConfirmation';
export const FLIGHT_MAKE_PAYMENT  = 'flightMakePayment';
export const FLIGHT_RETRIVE_BOOKING = 'flightRetrieveBooking';
export const FLIGHT_FARE_RULES = 'flightFareRules';
export const FLIGHT_BUY_TICKET = 'flightBuyTicket';
export const FLIGHT_CONFIRMATION = 'flightConfirmation';
export const APPLY_GLOBAL_PROMO_CODE = 'ApplyGlobalPromoCode'
export const INITIATE_STRIPE_PAYMENT = 'initiateStripePayment';
export const CREATE_PAYMENT_INTENT = 'createPaymentIntent';
export const FETCH_PAYMENT_AVAILIBILITY = 'fetchPaymentAvailibility';
export const SIGNIX_CONFIRMED_HOTEL = 'signixConfimedHotel';
export const SIGNIX_CANCEL_HOTEL = 'signixCancelHotel';

export const BLOGS_LISTING = 'blogsListing'
export const FETCH_BLOG_DETAIL = 'fetchBlogDetail'

export const FETCH_INTERNATIONAL_EVENTS = 'fetchInternationalEvents'
export const FETCH_INTERNATIONAL_TICKETS = 'fetchInternationalTickets'
export const FETCH_INTERNATIONAL_EVENTS_CATEGORIES = 'fetchInternationalEventsCategories'
export const FETCH_GENERAL_SEARCH = 'fetchGeneralSearch'
export const INTERNATIONAL_TICKET_ONHOLD = "internationalTicketOnhold"
export const TIXSTOCK_UPDATE_ORDER_STATUS = 'tixstockUpdateOrderStatus'
export const GET_ALL_CURRENCY_RATES = 'getAllCurrencyRates';
export const SET_ALL_CURRENCY_RATES = 'setAllCurrencyRates';
export const BUY_INTERNATIONAL_TICKET = "buyInternationalTicket"
export const TIXSTOCK_CONFIRMATION_FARE = "tixstockConfirmationFare"
export const SET_TIXSTOCK_NAV_CATEGORIES = 'setTixstockNavCategories'
export const SET_FEATURED_CATEGORIES = 'setFeaturedCategories'
export const SET_TRENDING_CATEGORIES = 'setTrendingCategories'
export const SET_POPULAR_CATEGORIES = 'setPopularCategories'
export const FETCH_INTERNATIONAL_EVENTS_CATEGORIES_BY_ID = 'fetchInternationalEventsCategoriesById'
export const RELEASE_INTERNATIONAL_EVENT_HOLD_TICKET = 'releaseInternationalEventHoldTicket'